import * as React from 'react';
import * as moment from 'moment';
import {DatePicker} from 'antd';
import {MOMENT_DATE_FORMAT, toEndOfDay, toStartOfDay} from '../utils/date-utils';
import locales from '../locales';
import ButtonBar from "./ButtonBar";

interface Props {
    onRangeChanged: (start?: moment.Moment, end?: moment.Moment) => void;
    defaultStart?: moment.Moment;
    defaultEnd?: moment.Moment;
}

interface State {
    start?: moment.Moment;
    end?: moment.Moment;
}

export class DateRangePicker extends React.Component<Props, State> {
    public state: State = {
        start: this.props.defaultStart,
        end: this.props.defaultEnd
    };

    public render() {
        const {start, end} = this.state;
        return (
            <ButtonBar>
                <DatePicker
                    value={start}
                    placeholder={locales.checklist_start}
                    allowClear={true}
                    size={"small"}
                    format={MOMENT_DATE_FORMAT}
                    disabledDate={this.startDatePickerDisabledDateFn}
                    onChange={this.onStartChanged}
                />
                <DatePicker
                    value={end}
                    placeholder={locales.checklist_end}
                    allowClear={true}
                    size={"small"}
                    format={MOMENT_DATE_FORMAT}
                    disabledDate={this.endDatePickerDisabledDateFn}
                    onChange={this.onEndChanged}
                />
            </ButtonBar>

        )
    }

    private onStartChanged = (start: moment.Moment | null) => {

        this.setState({start: start ? toStartOfDay(start) : undefined});
        this.props.onRangeChanged(start ?? undefined, this.state.end);
    };

    private onEndChanged = (end: moment.Moment | null) => {
        this.setState({end: end ? toEndOfDay(end) : undefined});
        this.props.onRangeChanged(this.state.start, end ?? undefined);
    };

    private startDatePickerDisabledDateFn = (current: moment.Moment | null): boolean => {
        if (current !== null && this.state.end) {
            return current.isAfter(this.state.end);
        }
        return false;
    };

    private endDatePickerDisabledDateFn = (current: moment.Moment | null): boolean => {
        if (current !== null && this.state.start) {
            return current.isBefore(this.state.start);
        }
        return false;
    };
}


// WEBPACK FOOTER //
// ./src/common/DateRangePicker.tsx